/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { eitherOrWithCount, trackingURL } from '@xingternal/xing-tracking';
import { PlaceholderLi, PlaceholderIcon, PlaceholderText, PlaceholderItemText, StyledIconWithBadge, StyledLink, StyledTitle, } from './nav-item.styles';
const keyToMembershipType = (key) => {
    switch (key) {
        case 'premium':
        case 'premiumUpsell':
            return 'premium';
        case 'proJobs':
        case 'proJobsUpsell':
            return 'proJobs';
        case 'proBusiness':
        case 'proBusinessUpsell':
            return 'proBusiness';
        default:
            return undefined;
    }
};
const NavItemPlaceholder = () => {
    return (React.createElement(PlaceholderLi, null,
        React.createElement(PlaceholderIcon, null),
        React.createElement(PlaceholderText, null,
            React.createElement(PlaceholderItemText, null))));
};
const NavItem = ({ item, activeItem, notifications }) => {
    const isActive = item.key === activeItem;
    const notificationCount = notifications && notifications[item.notificationKey || ''];
    const IconElement = isActive ? item.activeIcon : item.icon;
    const trackingConditions = {
        sc_o_PropActionOrigin: eitherOrWithCount(notificationCount),
    };
    return (React.createElement("li", null,
        React.createElement(StyledLink, { "$isActive": isActive, "$membership": keyToMembershipType(item.key), "data-qa": `frame-vnav-${item.key}`, to: trackingURL(item.href, 'tracking', trackingConditions)(item) },
            React.createElement(StyledIconWithBadge, { "$membership": keyToMembershipType(item.key), icon: IconElement, title: item.title, count: notificationCount }),
            React.createElement(StyledTitle, { "$size": "long" }, item.title),
            React.createElement(StyledTitle, { "$size": "short" }, item.titleShort || item.title))));
};
NavItem.defaultProps = {
    notifications: {},
};
NavItem.propTypes = {
    // xingConnect
    activeItem: PropTypes.string,
    notifications: PropTypes.object,
    // props
    item: PropTypes.shape({
        icon: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
        activeIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
        title: PropTypes.string.isRequired,
        titleShort: PropTypes.string,
        key: PropTypes.string.isRequired,
        href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
        notificationKey: PropTypes.string,
    }).isRequired,
};
export { NavItem, NavItemPlaceholder };
//# sourceMappingURL=nav-item.js.map